// extracted by mini-css-extract-plugin
export var box = "_redotech-redo-web-lib-checkbox-box";
export var check = "_redotech-redo-web-lib-checkbox-check";
export var checkboxButton = "_redotech-redo-web-lib-checkbox-checkbox-button";
export var checkboxGroup = "_redotech-redo-web-lib-checkbox-checkbox-group";
export var disabled = "_redotech-redo-web-lib-checkbox-disabled";
export var ghost = "_redotech-redo-web-lib-checkbox-ghost";
export var input = "_redotech-redo-web-lib-checkbox-input";
export var label = "_redotech-redo-web-lib-checkbox-label";
export var normal = "_redotech-redo-web-lib-checkbox-normal";
export var uncheck = "_redotech-redo-web-lib-checkbox-uncheck";